import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'
import { compact } from 'lodash'

export default {
  computed: {
    instantSearchMiddlewares () {
      return compact([this.insightsMiddleware])
    },
    insightsMiddleware () {
      if (!this.$searchInsights) { return }

      return createInsightsMiddleware({
        insightsClient: this.$searchInsights,
        onEvent: event => {
          if (!this.$config.PRODUCTION) { return }

          const { insightsMethod, eventType, payload } = event

          if (eventType === 'view') {
            this.$searchInsights(insightsMethod, payload)
          }

          this.$nextTick(() => { window.dataLayer.push({ event: payload.eventName }) })
        }
      })
    }
  },
  methods: {
    sendItemClickedEvent (sendEvent, item, type) {
      sendEvent('click', item, `${type}_clicked`)
    }
  }
}